import {reset as fcReset, disableSubmitButtons as fcDisable} from '../widgets/friendlyCaptcha';
import {reset as grReset} from '../widgets/googleRecaptcha';
import {elementToSelector} from '../utils/element';

/* eslint-disable import/prefer-default-export */

/**
 * @param {HTMLFormElement} form - form that contains a captcha to be reset
 */
export const resetCaptcha = form => {
    if (form) {
        if (window.grecaptcha) {
            const input = form.querySelector('.recaptchaResponse');
            grReset(input);
        } else if (window.friendlyChallenge) {
            fcDisable(form);
            fcReset(`${elementToSelector(form)} .frc-captcha`, true);
        }
    }
};
